<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderRight :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <div class="container">
        <Activation />
        <div class="text-center mt-5 ">
            <p class="font-italic">
                This is subscription service offered exclusively by Culture Square LLC. For now, it is exclusively in United States, and will be rolled out globally with time.
            </p>
            <p>For as little as $25 per month you will have the opportunity to add little bit of diversity to your annual most celebrated dates and moments. Our event’s organizers will deliver the best cultural experience to spice up your special moment for eternity.
            </p>
            <p class="sub-main-text">Select your plan and save the date</p>

        </div>
        <b-row class="mt-5">
            <b-col cols="12" md="4">
                <div class="custome-card custom-h card-body mb-3">
                    <p class="text-center">
                        <b-icon class="culture-primary" font-scale="3" icon="person"></b-icon>
                    </p>
                    <p class="font-weight-bold text-center">Individual Plan </p>
                    <p class="pl-4 font-italic text-center">For personal private events</p>
                    <p class="text-center font-weight-bold font20">$25 / month</p>
                    <ul class="ml-3 plan mt-1 p-5">
                        <li>1 — 5 servings</li>
                        <li>1 International country choice</li>
                        <li>Menu provided</li>
                    </ul>
                    <div class="btn-holder">
                        <button @click="selectPlan" class=" btn btn-warning text-white">Select
                            <font-awesome-icon :icon="['fas', 'arrow-right']" />
                        </button>
                    </div>

                </div>
            </b-col>
            <b-col cols="12" md="4">
                <div class="custome-card custom-h card-body mb-3">
                    <p class="text-center">
                        <b-icon class="culture-primary" font-scale="3" icon="briefcase"></b-icon>
                    </p>
                    <p class="font-weight-bold text-center">Professional Plan </p>
                    <p class="pl-4 font-italic text-center">For organized events</p>
                    <p class="text-center font-weight-bold font20">$75 / month</p>
                    <ul class="ml-3 plan mt-1 p-5">
                        <li># of serving determined by client</li>
                        <li>Up to 3 International country choices</li>
                        <li>Menu provided</li>
                        <li>A planned cultural show</li>
                    </ul>
                    <div class="btn-holder">
                        <button @click="selectPlan" class=" btn btn-warning text-white">Select
                            <font-awesome-icon :icon="['fas', 'arrow-right']" />
                        </button>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <div class="custome-card custom-h card-body mb-3">
                    <p class="text-center">
                        <b-icon class="culture-primary" font-scale="3" icon="building"></b-icon>
                    </p>
                    <p class="font-weight-bold text-center">Enterprise Plan </p>
                    <p class="pl-4 font-italic text-center">For companies and public events</p>
                    <p class="text-center font-weight-bold font20">$250 / month</p>
                    <ul class="ml-2 plan mt-1 p-5">
                        <li># of serving determined by client</li>
                        <li>Up to 5 International country choices</li>
                        <li>Menu provided</li>
                        <li>Sampling at least 2 weeks prior</li>
                        <li>A planned cultural show</li>
                    </ul>
                    <div class="btn-holder">
                        <button @click="selectPlan" class=" btn btn-warning text-white">Select
                            <font-awesome-icon :icon="['fas', 'arrow-right']" />
                        </button>
                    </div>
                </div>
            </b-col>
        </b-row>
        <div class="text-center mt-4">
            Start paying your plan. For more questions see <router-link class="culture-primary" to="/faqs"> FAQs </router-link> and click on subscription.
        </div>
        <b-modal id="subscribe-plan" centered title="Subscribe" hide-footer>
            <form @submit.prevent="enrol">
                <div class="row" style="margin-left:0 !important">
                    <b-form-group class="col-md-6 mb-3" label-for="firstName">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="person"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" required v-model="first_name" placeholder="First Name"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-3" label-for="lastName">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="person"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" required v-model="last_name" placeholder="Last Name"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-12 mb-3" label-for="lastName">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="question-circle"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" required v-model="reason" placeholder="Reason for subscription"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                     
                    <b-form-group class="col-md-12 mb-4" label-for="end_day">
                        <b-form-datepicker :min="mindate" no-flip required v-model="event_start" placeholder="Event Date"></b-form-datepicker>
                    </b-form-group>
                    <b-form-group class="col-md-12  mb-4" label-for="event-details">
                        <textarea style="height:auto !important;" required v-model="message" rows="4" placeholder="Describe the event in more details" class="custome-card form-control"></textarea>
                    </b-form-group>
                    <b-form-group class="col-md-12  mb-4" label-for="event-details">
                        <button class="btn btn-warning btn-below">
                            {{sendbtnText}}
                            <b-icon font-scale="0.99" icon="arrow-right"></b-icon>
                        </button> </b-form-group>

                </div>
            </form>
        </b-modal>
    </div>

    <Footer />

</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderRight from "@/components/BlackHeaderRight.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";

export default {
    name: "about-us",
    data: function () {
        return {
            headerText: "Subscriptions",
            headerTextEmpahasis: "!",
            subText: "Subscription offers for culture square.",
            fadedText: "Subscribe",
            sendbtnText: 'Subscribe',
            message: '',
            first_name: '',
            last_name: '',
            reason: '',
            event_start: '',
            mindate: new Date(),
        }
    },
    components: {
        Header,
        BlackHeaderRight,
        BlackHeaderMobile,
        BodyLinks,
        Activation,
        Footer
    },
    methods: {
        selectPlan() {
            this.$bvModal.show("subscribe-plan")
        },
        enrol() {
            console.log('enrolling')
        },
        reasonChange() {
            console.log('chaning reason')
        }
    }
}
</script>

<style lang="scss" scoped>
.mb-5 {
    margin-bottom: 5rem !important
}

.plan {
    list-style-type: disc !important;
}

.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 15px) !important;

}

.btn-holder {
    position: absolute;
    bottom:30px;
    left: 50%;
    transform: translate(-50%, 0);
    @media screen and (min-device-width: 320px) and (max-device-width: 740px) and (-webkit-min-device-pixel-ratio: 1) {
        position: relative;
        bottom: 10px;
        text-align: center;
    }
}

.custom-h {
    height: 100%;
    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        height: auto !important
    }
}

.btn-warning {
    padding: 10px 30px;
}

@media screen and (min-width: 1400px) {
    .culture-section {
        background-repeat: no-repeat;
        background-size: cover;
    }
}
</style>
